/*
 * @Author: 01399133
 * @Date: 2021-06-07 17:40:02
 * @LastEditors: 01387189
 * @LastEditTime: 2021-07-22 10:44:20
 * @Description: file content
 */
import Vue from "vue";
import {
  Modal,
  Button,
  Affix,
  FormModel,
  Input,
  InputNumber,
  Select,
  Icon,
  Row,
  select,
  Col,
  Checkbox,
  Radio,
  Message,
  Table,
  Upload,
  Popconfirm,
  ConfigProvider,
  Tabs,
  tooltip,
  Spin,
  Layout,
  Menu,
  Dropdown,
  Result,
  Tag,
  Pagination,
  Carousel,
  Divider,
  DatePicker,
} from "ant-design-vue";
import "@/styles/ant-vue.less";
import "@/styles/reset.less"; //写在这里可以覆盖ant的全局样式影响

Vue.use(select);
Vue.use(Carousel);
Vue.use(Modal);
Vue.use(Button);
Vue.use(Affix);
Vue.use(FormModel);
Vue.use(Input);
Vue.use(InputNumber);
Vue.use(Select);
Vue.use(Icon);
Vue.use(Row);
Vue.use(Col);
Vue.use(Checkbox);
Vue.use(Radio);
Vue.use(Message);
Vue.use(Table);
Vue.use(Upload);
Vue.use(Popconfirm);
Vue.use(ConfigProvider);
Vue.use(Tabs);
Vue.use(tooltip);
Vue.use(Spin);
Vue.use(Layout);
Vue.use(Menu);
Vue.use(Dropdown);
Vue.use(Result);
Vue.use(Tag);
Vue.use(Pagination);
Vue.use(Carousel);
Vue.use(Divider);
Vue.use(DatePicker);
Message.config({
  top: `100px`,
});
